import UpSelectBtn, { KEY } from './UpSelectBtn';
import { playOrder, playTime } from './useCarousel';
import React from 'react';
import { effectList } from './effects/EffectConfig';
import ReactSVG from 'react-svg';
import { ICarouselConfig } from './AllForCarousel';

interface ICarouselControlBtns {
  config: ICarouselConfig;
  setTheConfig: (key: string, value: KEY) => void;
  onStart:()=>void;
  onPause:()=>void;
  isPlaying:boolean;
  simple?:boolean;
}
export default function(props: ICarouselControlBtns) {
  const { config, setTheConfig, onStart, onPause, isPlaying, simple} = props;
  return (
    <>
      {!simple ? <React.Fragment>
        <div className="carousel-danmuku-switch" onClick={()=>{
          setTheConfig('danmuku', Number(config.danmuku) == 0 ? 1 : 0);
        }}>
          <ReactSVG src={config.danmuku ? require('../../svg/danmuku-on.svg') : require('../../svg/danmuku-off.svg')} />
        </div>
        <div className="carousel-qrcode-switch" onClick={()=>{
          setTheConfig('qrcode', Number(config.qrcode) == 0 ? 1 : 0);
        }}>
          {Number(config.qrcode) ? '隐藏二维码' : '显示二维码'}
        </div>
      </React.Fragment> : null}
      <UpSelectBtn
        selectKey={config.order}
        list={playOrder}
        setKey={key => setTheConfig('order', key)}
      />
      <UpSelectBtn
        // 内容长短不一，所以固定宽度
        style={{ width: 80 }}
        selectKey={config.time}
        list={playTime}
        setKey={key => setTheConfig('time', key)}
      />
      <UpSelectBtn
        style={{ width: 120 }}
        selectKey={config.effect}
        list={effectList}
        setKey={key => setTheConfig('effect', key)}
      />
      <div className="carousel-play" onClick={()=>{
        if(!isPlaying) {
          onStart();
        }else {
          onPause();
        }
      }}>
        {isPlaying ? '暂停播放' : '开始播放'}
      </div>
    </>
  );
}
